module.exports = __webpack_public_path__ + "img/step-icon-docs-eval.e37dc249.svg";